import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AppDownloadSuggestionService } from './shared/services/app-download-suggestion.service';
import { AppConfigService } from 'lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  loaded = false;
  constructor(
    private titleController: Title,
    private adg: AppDownloadSuggestionService,
    private configService: AppConfigService
  ) {

    this.adg.downloadApp();
      this.configService.getApp().subscribe(config => {
        this.titleController.setTitle(config.title);
      });
  }
}
